<template>
  <v-card
    v-if="vatRate"
  >
    <v-card-title class="justify-space-between">
      VAT Rate
    </v-card-title>

    <v-card-text class="overflow-y-auto wh-600">
      <v-form>
        <v-container>
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <translations-tabs>
                <template #default="{language}">
                  <translatable
                    :language="language"
                    v-model="vatRate"
                    field-name="name"
                  >
                    <template
                      #default="{ fieldValue, fieldMutator }"
                    >
                      <v-text-field
                        v-model="fieldValue"
                        :error-messages="vatRate.displayErrors('name')"
                        :label="$t('VAT name')"
                        outline
                        @change="fieldMutator(fieldValue)"
                      />
                    </template>
                  </translatable>
                </template>
              </translations-tabs>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.number="vatRate.value"
                :error-messages="vatRate.displayErrors('value')"
                :label="$t('VAT %')"
                outline
              />
            </v-flex>
            <v-flex xs12>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>
                      <span>{{ $t('Products') }} </span>
                      <span v-if="vatRate.product_ids.length">({{ vatRate.product_ids.length }} - {{ $t('may include not listed children') }})</span>
                    </div>
                  </template>
                  <v-card>
                    <settings-vat-products
                      v-if="vatRate"
                      :vat="vatRate"
                    />
                  </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div>
                      <span>{{ $t('Shipping Methods') }} </span>
                      <span v-if="vatRate.shipping_ids.length">({{ vatRate.shipping_ids.length }})</span>
                    </div>
                  </template>
                  <v-card>
                    <settings-vat-shippings
                      v-if="vatRate"
                      :vat="vatRate"
                    />
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="vatRate.id"
        color="darken-1"
        flat
        small
        @click="remove"
      >
        {{ $t('Delete') }}
      </v-btn>

      <v-spacer/>
      <v-btn
        color="darken-1"
        flat
        small
        @click="$emit('closed')"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn
        color="primary darken-1"
        flat
        small
        @click="save"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SettingsVatProducts from '@/modules/Settings/components/Taxes/SettingsVatProducts'
import SettingsVatShippings from '@/modules/Settings/components/Taxes/SettingsVatShippings'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'

export default {
  name: 'SettingsVatRate',
  components: { Translatable, TranslationsTabs, SettingsVatShippings, SettingsVatProducts },
  props: {
    vat: {
      type: Object,
      default: () => {
      }
    }
  },

  data () {
    return {
      vatRate: null
    }
  },

  async mounted () {
    if (!this.vat || !this.vat.id) {
      this.vatRate = this.$http.make('vat')
      return
    }

    this.vatRate = await this.$http.make('vat').find(this.vat.id)
  },

  methods: {
    async save () {
      if (!this.vatRate.product_ids) {
        this.vatRate.product_ids = []
      }

      if (!this.vatRate.shipping_ids) {
        this.vatRate.shipping_ids = []
      }

      await this.vatRate.save()
      this.$emit('saved')
    },

    async remove () {
      await this.vatRate.delete()
      this.$emit('saved')
    }
  }
}
</script>

<style scoped>
.overflow-y-auto {
  overflow-y: auto !important
}

.wh-600 {
  max-height: 600px
}
</style>
